import React, { ReactNode, useContext, useRef, useState } from "react";
import {
  Button,
  Form,
  Image,
  InputNumber,
  Message,
  Popconfirm,
  Popover,
  Input,
  Switch,
  Tooltip,
  Modal, Select,
} from "@arco-design/web-react";
const { Option } = Select;
import OpenDrawer from "../../../VideoConfig/OpenDrawer/OpenDrawer";
import mute from "@/assets/cut-mix-detail/video-group-mute.png";
import notMute from "@/assets/cut-mix-detail/video-group-not-mute.png";
import editImg from "@/assets/cut-mix-detail/pencil.png";
import deleteImg from "@/assets/cut-mix-detail/delete.png";
import copyingImg from "@/assets/cut-mix-detail/color_title.png";
import lineImg from "@/assets/cut-mix-detail/color_sound.png";
import EditText, {
  IforwardRef,
} from "@/pages/CreationSpace/components/EditText/EditText";
import VideoItemBlock from "./VideoItemBlock/VideoItemBlock";
import Ton from "@/components/Hocicon";
import SelfUploadBlock from "../../../Components/SelfUploadBlock/SelfUploadBlock";
import errorImg from "@/assets/cut-mix-detail/error.png";
import useCaption from "@/useStore/mixCutDetail/useCaption";
import loadingSvg from "@/assets/create-space/loading.svg";
import useTitle from "@/useStore/mixCutDetail/useTitle";
import useMixCutDetail from "@/useStore/mixCutDetail/useMixCutDetail";
import captionPlayerImg from "@/assets/cut-mix-detail/caption-playing.gif";
import "./VideoGroupItem.less";
import ConfigStore from "@/stores/mixedConfig/index";
import {
  IMaterailGroupSetting,
  IMaterialFile,
  TypeClipRule,
  TypeSpeed,
} from "@/stores/mixCutDetailStore/type";
import { formatTime } from "@/components/business/VideoHoc/VideoHoc";
import { mixCutDetailContext } from "../../../index";
import { unBindVideoMaterial } from "@/services/mixCutDetail/mixCutDetail";
import useMaterialPlayInfo from "@/useStore/mixCutDetail/useMaterialPlayInfo";
import { useParams } from "react-router-dom";
import useVideoGroup from "@/useStore/quickCut/useVideoGroup";
import Modals from "@/components/UI/Modals";
import { RequestStatus } from "@/requestHooks/common";
import iconImg from "@/assets/create-space/project-modal-icon.png";
import FormItem from "@arco-design/web-react/es/Form/form-item";
import VoLongButton from "@/components/VLButton/VLButton";
import QuickCutStore from "@/stores/quickCutStore";
import QuickStore from "@/stores/quickCutStore";
import { observer } from "mobx-react";
const speedSelect = [
  { value: "origin", label: "原始时长" },
  { value: "follow_audio", label: "随音频变速" },
];

const ClipRuleSelect = [
  { value: "auto", label: "智能魔剪" },
  { value: "single_times", label: "单次魔剪" },
  { value: "single_video", label: "单视频魔剪" },
];

export interface IVideoGroupItemProps {
  sencesIndex: number;
  error?: string;
  active: boolean;
  handleHeaderClick: () => void;
  name: string;
  materials: IMaterialFile[];
  materialMute: boolean;
  disabled: boolean;
  speed: string;
  clipRule: string;
  hanldeMaterialChange: (materials: IMaterialFile[]) => void;
  handleNameChange: (name: string) => void;
  handleSetting: (key, state) => void;
  handleDeleteBtnClick: () => void;
  handleUploadBtnClick: (type: "material" | "local") => void;
  handleEditBtnClick: (index: number) => void;
  onClick: () => void;
  isDragging: boolean;
  dragHandleProps?: any;
  videoStatusList: any;
  type: number;
  duration: number;
  settings?: any
}

const toMaterialsGetDurationRange = (data: IMaterialFile[]): ReactNode => {
  if (!data || data.length === 0) {
    return null;
  }
  if (data && data.length === 1) {
    return (
      <>
        {`${formatTime(data[0].duration)}`}
        <span>s</span>
      </>
    );
  }
  if (data && data.length > 1) {
    let newData = [...data];
    newData = newData.sort((a, b) => a.duration - b.duration);
    return (
      <>
        {formatTime(newData[0].duration)}
        <span>s</span>~{formatTime(newData[newData.length - 1].duration)}
        <span>s</span>
      </>
    );
  }
};

const VideoGroupItem: React.FC<IVideoGroupItemProps> = observer((props) => {
  const {
    error,
    active,
    handleHeaderClick,
    name,
    materials,
    materialMute,
    disabled,
    speed,
    clipRule,
    handleNameChange,
    handleSetting,
    handleDeleteBtnClick,
    hanldeMaterialChange,
    handleUploadBtnClick,
    handleEditBtnClick,
    isDragging,
    dragHandleProps,
    onClick,
    videoStatusList,
    type,
    duration,
    settings,
    sencesIndex
  } = props;
  const { videoGroupActive, setVideoGroupActive } =
    useContext(mixCutDetailContext);
  const [options] = useState([
    { label: '素材原始时长', value: 'origin' },
    { label: '跟随解说时长', value: 'follow_audio' },
    { label: '自定义分镜时长', value: 'custom' },
  ])
  const { general } = QuickCutStore.quickcutData.settings
  const [openState, setOpenState] = useState(true);
  const { toIdGetIsRepeat } = useVideoGroup();
  const { id: projectId } = useParams();
  const { toIdDeleteMaterailPlayInfo } = useMaterialPlayInfo();
  const EditTextRef = useRef<IforwardRef>(null);
  const [changeTime, setChangeTime] = useState(false);
  const editSetting = (key, state) => {
    try {
      handleSetting( key,state);
    } catch (e) {
      console.log(e);
    }
  };

  const deleteVideo = async (id: string) => {
    const newMaterials = materials.filter((item) => item.id != id);
    if (!toIdGetIsRepeat(id)) {
      toIdDeleteMaterailPlayInfo(id);
      try {
        await unBindVideoMaterial(Number(projectId), Number(id));
      } catch (e) {
        console.log(e);
      }
    }
    hanldeMaterialChange(newMaterials);
  };

  return (
    <div
      onClick={() => {
        onClick();
      }}
      className={`${active && !QuickStore.quickcutData.global ? "active" : ""} video-group-item-wrapper1 ${error ? "error" : ""}`}>
      <div
        className={`video-group-item-header`}
        {...dragHandleProps} // 应用 dragHandleProps 到 header
        onClick={(e) => {
          if (isDragging) return false;
          if (handleHeaderClick) {
            handleHeaderClick();
            // 使当前页面上所有聚焦的元素失去焦点
            if (
              document.activeElement &&
              document.activeElement !== document.body
            ) {
              (document.activeElement as any).blur();
            }
          }
        }}>
        <div className="name-wrapper">
          <OpenDrawer state={openState} handleStateChange={setOpenState} />
          <EditText
            disabed={true}
            ref={EditTextRef}
            name={name}
            handleInputEndEnter={(e) => {
              if (e.length === 0) {
                Message.error("请填写镜头组名称");
                return;
              }
              if (e.length > 20) {
                Message.error("镜头组名称不能超过20个字");
                return;
              }
              handleNameChange(e);
              EditTextRef.current.toggleIsEdit();
            }}
            style={{ width: "auto" }}
          />
          ({materials?.length || 0})
          {
            !QuickCutStore.quickcutData.global && type === 2 && <Select
                  value={settings?.general?.mode || 'follow_audio'}
                  onChange={(e) => {
                    QuickCutStore.quickcutData.scenes[sencesIndex].settings.general.mode = e;
                    editSetting("duration", 0);
                  }}
                  style={{height: 34, width: 140, marginLeft: 20}}
                  placeholder="请选择"
              >
              {options.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.label}
                </Option>
              ))}
              </Select>
          }
          {error ? (
            <Popover
              className={"video-popover-error"}
              trigger="hover"
              content={
                <p className="content">
                  <img
                    src={errorImg}
                    style={{ width: "20px", height: "20px" }}
                  />
                  <div className="error-message">{error}</div>
                </p>
              }>
              <img src={errorImg} style={{ width: "20px", height: "20px" }} />
            </Popover>
          ) : (
            <></>
          )}
          {
            (QuickCutStore.quickcutData.global && general.mode === 'custom' && type === 2 || !QuickCutStore.quickcutData.global && settings?.general?.mode === 'custom') && (sencesIndex !== QuickCutStore.editDuration ? <div onClick={() => {
                QuickCutStore.editDuration = sencesIndex
              }} className={'has-duration'}>分镜时长(s)：{ duration }</div> :
              <InputNumber min={0} max={60} value={duration} onClick={(e) => {
                e.stopPropagation();
              }} hideControl onBlur={(e) => {
                editSetting("duration", Number(e.target.value) > 60 ? 60 : Number(e.target.value));
                QuickCutStore.editDuration = null
              }} style={{ width: 150, marginLeft: 10 }}  precision={2} placeholder={'请输入分镜时长(s)'}></InputNumber>)
          }
        </div>
        <div className="opeator">
          <Tooltip position="top" trigger="hover" content="编辑镜头名称">
            <img
              src={editImg}
              className="hover-display-img"
              style={{ width: 20, marginRight: 13 }}
              alt=""
              onClick={(e) => {
                EditTextRef.current.toggleIsEdit();
                e.stopPropagation();
              }}
            />
          </Tooltip>

          {!materialMute ? (
            <Tooltip position="top" trigger="hover" content="静音">
              <img
                src={mute}
                className="hover-display-img"
                style={{ width: 20, marginRight: 13 }}
                alt=""
                onClick={(e) => {
                  editSetting("material_mute", true);
                  e.stopPropagation();
                }}
              />
            </Tooltip>
          ) : (
            <Tooltip position="top" trigger="hover" content="解除静音">
              <img
                src={notMute}
                className="hover-display-img"
                style={{ width: 20, marginRight: 13 }}
                alt=""
                onClick={(e) => {
                  editSetting("material_mute", false);
                  e.stopPropagation();
                }}
              />
            </Tooltip>
          )}
          <Popconfirm
            focusLock
            title="确认删除该组镜头？"
            content=""
            onOk={(e) => {
              e.stopPropagation();
              handleDeleteBtnClick();
            }}
            onCancel={(e) => {
              e.stopPropagation();
              console.log("取消");
            }}>
            <Tooltip position="top" trigger="hover" content="删除">
              <img
                onClick={(e) => {
                  e.stopPropagation();
                }}
                src={deleteImg}
                className="hover-display-img"
                style={{ width: 20, marginRight: 13 }}
                alt=""
              />
            </Tooltip>
          </Popconfirm>
          <div className="duration-range">
            {toMaterialsGetDurationRange(materials)}
          </div>
        </div>
      </div>
      <div
        className={`${openState ? "" : "hidden"} video-group-item-container`}>
        {materials?.length > 100 ? (
          <></>
        ) : (
          <Ton
            showHover={false}
            style={{ width: 126, height: 161, marginBottom: 0 }}
            contel={
              <SelfUploadBlock style={{ width: "100%", height: "100%" }} onClick={() => {
                handleUploadBtnClick("material");
              }} />
            }>
          </Ton>
        )}

        <div className="video-group-material-wrapper">
          {materials?.length > 0 && materials.map((item, index) => {
            return (
              <VideoItemBlock
                videoStatusList={videoStatusList}
                isCropped={item.is_cropped}
                handleEditBtnClick={() => {
                  handleEditBtnClick(index);
                }}
                duration={formatTime(item.duration)}
                key={item.media_id}
                data={item}
                handleCloseBtnClick={(id: string) => {
                  deleteVideo(id);
                }}
                style={{
                  width: "125px",
                  height: "160px",
                  marginLeft: 15,
                  borderRadius: 8,
                  overflow: "hidden",
                }}></VideoItemBlock>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default VideoGroupItem;
